import { IBaseState } from "../../index";
import {
  IReportPrintTemplateModel,
  ReportPrintTemplateLookupModel,
  ReportPrintTemplateModel,
} from "../../../models/report";

/**
 *
 */
export interface IPrintTemplateState extends IBaseState<{}, {}> {
  service?: {};
  propertyService?: {};
  projectService?:{};
  demandService?: {};
  personService?: {};
  printTemplate?: IReportPrintTemplateModel;
  printTemplateLookup?: ReportPrintTemplateLookupModel;
}

/**
 * define report state by vuex
 */
export class PrintTemplateState implements IPrintTemplateState {
  service?: {};
  propertyService?:{};
  projectService?:{};
  demandService?: {};
  personService?: {};
  printTemplate?: IReportPrintTemplateModel;
  printTemplateLookup?: ReportPrintTemplateLookupModel;
  constructor(options: IPrintTemplateState) {
    this.printTemplate = new ReportPrintTemplateModel();
    this.printTemplateLookup = new ReportPrintTemplateLookupModel();
    this.service = options.service;
    this.propertyService = options.propertyService;
    this.projectService = options.projectService;
    this.demandService = options.demandService;
    this.personService = options.personService;
  }
}
